import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export const HOME_AND_LIVING_PBKS = new Set([
    'aufbewahrungsboxen',
    'bettlaken',
    'bettwäsche',
    'bilder',
    'dekofiguren',
    'gardinen',
    'handtücher',
    'hocker',
    'kissen',
    'kunstpflanzen',
    'pflanzgefäße',
    'regale',
    'schränke',
    'sessel',
    'sideboards',
    'sitzbänke',
    'sofas',
    'spiegel',
    'stühle',
    'teppiche',
    'tische',
    'wanduhren',
]);

export function isCutoutTreatment(onex: OnEx | undefined): boolean {
    return onex?.isExperimentGroup('CUTOUT_IMAGE', 'E3851B') ?? false;
}

export function isCutoutAllowedForPbk(pbk: string | undefined): boolean {
    if (pbk === undefined) return false;
    return HOME_AND_LIVING_PBKS.has(pbk.toLowerCase());
}
